import React, { Fragment } from "react";
import PropTypes from "prop-types";

import { materialType } from "~/constants/prop-types";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Clear";

import InlineToolbar from "~/components/InlineToolbar";
import { styled } from "@mui/material/styles";
import Form from "../Form";

const StyledDialogTitle = styled(DialogTitle)({
  position: "relative",
  margin: 0,
  padding: 0,
  display: "flex",
  alignItems: "center"
});

const StyledTypography = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  marginLeft: 0,
  marginRight: "auto"
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(0, 0, 2, 0)
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  "&:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-2px"
  }
}));

function EditModal({ hideModal, material, onSubmit, onDelete, kind }) {
  return (
    <>
      <StyledDialogTitle>
        <StyledTypography variant="h6" id={`${kind}-modal-title`}>
          Angaben bearbeiten
        </StyledTypography>

        <InlineToolbar>
          <StyledIconButton onClick={hideModal} size="large" aria-label="Schließen">
            <CloseIcon />
          </StyledIconButton>
        </InlineToolbar>
      </StyledDialogTitle>

      <StyledDialogContent>
        <Form onSubmit={onSubmit} material={material} canEdit={true} onDelete={onDelete} />
      </StyledDialogContent>
    </>
  );
}

EditModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  classes: PropTypes.object,
  material: materialType,
  onSubmit: PropTypes.func,
  onDelete: PropTypes.func,
  kind: PropTypes.string.isRequired
};

EditModal.whyDidYouRender = false;

export default EditModal;
